const initMegaMenu = () => {
  const headerMenu = document.querySelector('header-menu');
  if (!(headerMenu instanceof HTMLElement)) return;

  headerMenu.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openTrigger = headerMenu.querySelector('[ref="menuitem"][aria-expanded="true"]');
    if (!(openTrigger instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();

    const item = openTrigger.closest('.menu-list__list-item');
    if (!(item instanceof HTMLElement)) return;

    // Use the theme component's public API so its internal active state resets.
    // `deactivate()` expects an event-like object with a `target`.
    /** @type {{ deactivate: (event: { target: Element }) => void }} */
    const headerMenuComponent = /** @type {any} */ (headerMenu);
    headerMenuComponent.deactivate({ target: item });

    openTrigger.focus({ preventScroll: true });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMegaMenu, { once: true });
} else {
  initMegaMenu();
}

export {};
